// validationSchema.ts
import * as yup from "yup";

export const menusSchema = yup.object().shape({
  pagina: yup.string().required("O nome da página é obrigatória"),
  link: yup.string().nullable().default(null),
  divisor: yup.boolean().default(false),
  config: yup.boolean().default(false),
  ordem: yup.number().required("A ordem de exibição é obrigatória"),
});
